export enum PaletteType {
  EXTERIOR_PALETTE = "EXTERIOR_PALETTE",
  INTERIOR_PALETTE = "INTERIOR_PALETTE",
}
